export default __webpack_public_path__ + "static/media/github.fe6009c8.svg";